import { render } from "./CategoryBox.vue?vue&type=template&id=660817c8&scoped=true"
import script from "./CategoryBox.vue?vue&type=script&lang=js"
export * from "./CategoryBox.vue?vue&type=script&lang=js"

import "./CategoryBox.vue?vue&type=style&index=0&id=660817c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660817c8"]])

export default __exports__